/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isValidTimestamp } from '@customerio/fly-components/utils/validators/timestamp';

interface DeviceAttributeValueArgs {
  attribute: { name: string; value: string };
}

export default class DeviceAttributeValue extends Component<DeviceAttributeValueArgs> {
  get value() {
    return this.args.attribute.value;
  }

  get isTimestamp() {
    return isValidTimestamp(this.value);
  }
}
